import React, { useEffect } from "react";
import { useState } from '@hookstate/core';
import { Box, Paper, Typography } from "@mui/material";


const TableHeaderData = (props) => {
    // console.log(props);
    const [compCount, setCompCount] = React.useState(0);
    const [tempData, setTempData] = React.useState([]);

    let [ticketTypeData, setTicketTypeData] = React.useState([
        { id: 1, name: 'Complimentary', friAlloted: 0, friUsed: 0, satAlloted: 0, satUsed: 0, sunAlloted: 0, sunUsed: 0 },
        { id: 2, name: 'Purchase', friAlloted: 0, friUsed: 0, satAlloted: 0, satUsed: 0, sunAlloted: 0, sunUsed: 0 },
        { id: 3, name: 'Additional Purchase', friAlloted: 0, friUsed: 0, satAlloted: 0, satUsed: 0, sunAlloted: 0, sunUsed: 0 }
    ]);

    const [dayType, setDayType] = React.useState([
        { id: 1, name: 'Friday' },
        { id: 2, name: 'Saturday' },
        { id: 3, name: 'Sunday' }
    ])

    const cardcolor = {
        fricolor: '#E4EDFF',
        satcolor: '#C4D6FA',
        suncolor: '#95B5F3'
    }

    useEffect(() => {
        let parseData = null;
        if (Object.keys(props.newSettingData || {}).length !== 0) {
            parseData = JSON.parse(props?.newSettingData)
            // console.log("parseData", parseData, "compData", typeof props.compData, props.compData, Object.keys(props.compData || {}).length !== 0 ? "if" : 'else');
            setCompCount(parseData[0])
        }

        let fC = 0;
        let saC = 0;
        let suC = 0;
        // let tCnt = 0;
        let afC = 0;
        let asaC = 0;
        let asuC = 0;
        // console.log("props.purchaseData", props.purchaseData);
        if (props.purchaseData.length > 0) {
            props.purchaseData?.map((row) => {
                row.ticketAllStarDetails.map((value) => {
                    if (value.ticketNightID === 1) {
                        fC += value.ticketCount
                    } else if (value.ticketNightID === 2) {
                        saC += value.ticketCount
                    } else if (value.ticketNightID === 3) {
                        suC += value.ticketCount
                    }
                    // tCnt += (value.price * value.ticketCount)
                })
                row.ticketAllStarAdditionalPurchase.map((value) => {
                    setTempData(value)
                    if (value.ticketNightID === 1) {
                        afC += value.ticketCount
                    } else if (value.ticketNightID === 2) {
                        asaC += value.ticketCount
                    } else if (value.ticketNightID === 3) {
                        asuC += value.ticketCount
                    }
                    // tCnt += (value.price * value.ticketCount)
                })
            })
        }

        let compCount = parseData && parseData.length > 0 ? parseData[0] : null;
        let updatedTicketTypeInfo = [...ticketTypeData];
        updatedTicketTypeInfo[0].friAlloted = Number(compCount?.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketFriCompCount : 0);
        updatedTicketTypeInfo[0].friUsed = (Object.keys(props.compData || {}).length !== 0) ? (compCount && compCount.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketFriCompCount : 0) : 0;
        updatedTicketTypeInfo[0].satAlloted = Number(compCount?.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketSatCompCount : 0);
        updatedTicketTypeInfo[0].satUsed = (Object.keys(props.compData || {}).length !== 0) ? (compCount && compCount.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketSatCompCount : 0) : 0;
        updatedTicketTypeInfo[0].sunAlloted = Number(compCount?.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketSunCompCount : 0);
        updatedTicketTypeInfo[0].sunUsed = (Object.keys(props.compData || {}).length !== 0) ? (compCount && compCount.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketSunCompCount : 0) : 0;

        updatedTicketTypeInfo[1].friAlloted = Number(compCount?.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketFriPurCount : 0)
        updatedTicketTypeInfo[1].friUsed = fC;
        updatedTicketTypeInfo[1].satAlloted = Number(compCount?.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketSatPurCount : 0);
        updatedTicketTypeInfo[1].satUsed = saC;
        updatedTicketTypeInfo[1].sunAlloted = Number(compCount?.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketSunPurCount : 0);
        updatedTicketTypeInfo[1].sunUsed = suC;

        updatedTicketTypeInfo[2].friAlloted = Number(compCount?.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketFriAddPurCount : 0);
        updatedTicketTypeInfo[2].friUsed = afC;
        updatedTicketTypeInfo[2].satAlloted = Number(compCount?.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketSatAddPurCount : 0);
        updatedTicketTypeInfo[2].satUsed = asaC;
        updatedTicketTypeInfo[2].sunAlloted = Number(compCount?.TicketSetting ? JSON.parse(compCount?.TicketSetting)?.ticketSunAddPurCount : 0);
        updatedTicketTypeInfo[2].sunUsed = asuC;
        setTicketTypeData(updatedTicketTypeInfo);

    }, [props])
    // console.log(tempData,remainAddPurchaseNightCount.get());
    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    m: '10px',
                }}>
                <Typography
                    sx={{
                        fontWeight: 700,
                        lineHeight: '23.44px',
                        fontSize: '20px',
                        color: '#1D428A',
                    }}
                >USED TICKET SUMMARY</Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    width: '100%',
                    m: '16px 0px 16px 0px',
                    p: 1,
                    gap: '15px',
                }}>
                {dayType.map((day) => (
                    <Paper
                        key={day.id}
                        elevation={3}
                        sx={{
                            width: '240px',
                            height: '155px',
                            p: '10px',
                            backgroundColor:
                                day.name === 'Saturday'
                                    ? cardcolor.satcolor
                                    : day.name === 'Sunday'
                                        ? cardcolor.suncolor
                                        : cardcolor.fricolor,
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    fontWeight: 700,
                                    fontSize: '20px',
                                    lineHeight: '23.44px',
                                    color: '#1D428A',
                                    mb: '10px',
                                }}>
                                {day.name}
                            </Box>
                            {ticketTypeData.map((item) => (
                                <Box
                                    key={item.id}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        width: '100%',
                                    }}>
                                    <Box
                                        sx={{
                                            fontWeight: 400,
                                            fontSize: '15px',
                                            color: '#000000',
                                            lineHeight: '32px',
                                        }}>
                                        {item.name}
                                    </Box>
                                    <Box
                                        sx={{
                                            fontSize: '14px',
                                            lineHeight: '32px',
                                        }}>
                                        {day.name === 'Friday' && (
                                            <>
                                                {item.name == "Complimentary" ? <span
                                                    style={{ fontWeight: 400 }}>
                                                    {item.friAlloted}
                                                </span> : <span
                                                    style={{ fontWeight: 400 }}>
                                                    {item.friUsed}{' '}
                                                </span>}
                                                {item.name == "Purchase" ? <span>
                                                    of{' '}
                                                    <span
                                                        style={{ fontWeight: 400 }}>
                                                        {item.friAlloted}
                                                    </span>
                                                </span> : null}
                                            </>
                                        )}
                                        {day.name === 'Saturday' && (
                                            <>
                                                {item.name == "Complimentary" ? <span
                                                    style={{ fontWeight: 400 }}>
                                                    {item.satAlloted}
                                                </span> : <span
                                                    style={{ fontWeight: 400 }}>
                                                    {item.satUsed}{' '}
                                                </span>}
                                                {item.name == "Purchase" ? <span>of{' '}
                                                    <span
                                                        style={{ fontWeight: 400 }}>
                                                        {item.satAlloted}
                                                    </span>
                                                </span> : null}
                                            </>
                                        )}
                                        {day.name === 'Sunday' && (
                                            <>
                                                {item.name == "Complimentary" ? <span
                                                    style={{ fontWeight: 400 }}>
                                                    {item.sunAlloted}
                                                </span> : <span
                                                    style={{ fontWeight: 400 }}>
                                                    {item.sunUsed}{' '}
                                                </span>}
                                                {item.name == "Purchase" ? <span>of{' '}
                                                    <span
                                                        style={{ fontWeight: 400 }}>
                                                        {item.sunAlloted}
                                                    </span>
                                                </span> : null}
                                            </>
                                        )}
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Paper>
                ))}
            </Box>
        </>
    );
}

export default TableHeaderData;